import { translate } from './i18n/translate';

export function getMonthShort(month: string) {
  return translate(`charts.xAxis.month.${month}.short`);
}

export function getMonth(month: string) {
  return translate(`charts.xAxis.month.${month}`);
}
